/* eslint-disable no-unused-vars */
import { createApp } from 'vue'
import App from './App.vue'
import store, { pinia } from './store'
import localStore from './localStore'
import router from './router'
import { axiosAdminInstance, axiosInstance, axiosParticipantInstance, axiosSiteInstance } from './utils/axios'
import moment from './utils/moment'

window.moment = moment

import { Webrtc } from './utils/webrtc'
import i18n from './utils/i18n'
import { Utils } from './utils/utils'
import './theme/default.scss'
import DetectRTC from 'detectrtc'
import * as EBML from 'ts-ebml'
import jQuery from './utils/jquery'
window.jQuery = jQuery
window.$ = jQuery
import 'bootstrap'
import FileSelector from './components/library/FileSelector'
import NoSleep from './utils/nosleep'
import VuePassword from './components/library/VuePassword.vue'
import DatePicker from './components/library/PrimeVueDatePicker.vue'

import './utils/logger'
import { FontAwesomeIcon, FontAwesomeLayers } from '@fortawesome/vue-fontawesome'
import { dom, library } from '@fortawesome/fontawesome-svg-core'
import {
  faCircleExclamation,
  faVolume,
  faInfoCircle,
  faArrowUp,
  faArrowDown,
  faArrowLeft,
  faComment,
  faCommentLines,
  faPenRuler,
  faTrashCan,
  faLineHeight,
  faEraser,
  faHorizontalRule,
  faRotateLeft,
  faHandPointer,
  faCircle as faCircleLight,
  faSquare,
  faText,
  faHighlighter,
  faPencil,
  faBars,
  faMagnifyingGlassMinus,
  faMagnifyingGlassPlus,
  faEnvelopesBulk,
  faCopy,
  faEllipsisVertical,
  faClipboardListCheck,
  faUserHeadset,
  faCamera,
  faVideo,
  faVideoSlash,
  faMicrophone,
  faMicrophoneSlash,
  faSlash,
  faSpeaker,
  faComments,
  faSpinner,
  faRightFromBracket,
  faUserClock,
  faImagePolaroid,
  faAnglesUp,
  faAnglesDown,
  faAnglesLeft,
  faAnglesRight,
  faPaperPlane,
  faPaperclip,
  faQuestionSquare,
  faHeartCrack,
  faWebcam,
  faWebcamSlash,
  faXmark,
  faCheck,
  faUserLarge,
  faUserLargeSlash,
  faClock,
  faCalendar,
  faCalendarXmark,
  faChevronUp,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faTrash,
  faLink,
  faPlus,
  faMinus,
  faChartUser,
  faFilePdf,
  faTv,
  faAngleDown,
  faAngleUp,
  faSparkles,
  faLanguage,
  faPassport,
  faPlay,
  faBell,
  faBellOn,
  faTriangleExclamation,
  faFileAudio,
  faWaveformLines,
  faFileSignature,
  faHighlighterLine,
  faEyeDropper,
  faMapLocation,
  faVolumeXmark,
  faSquareXmark as faSquareXmarkLight,
  faCartShopping,
  faEnvelope,
  faQrcode,
  faCircleCheck,
  faCheckCircle, faTimesCircle, faQuestionCircle, faCalendarEdit, faPersonWalkingArrowRight, faUserLock
} from '@fortawesome/pro-light-svg-icons'
import {
  faPhoneHangup,
  faImage,
  faWifiSlash,
  faLinkSlash,
  faEnvelopeOpen,
  faTrash as faTrashSolid,
  faHeadset,
  faSpinner as faSolidSpinner,
  faFlashlight,
  faSquareXmark,
  faPause
} from '@fortawesome/pro-solid-svg-icons'
import { faTriangleExclamation as faTriangleExclamationSolid, faPhone, faCircle, faArrowRight, faVideo as faVideoSolid, faCirclePlay, faGear, faHand, faSquareXmark as faSquareXmarkFree } from '@fortawesome/free-solid-svg-icons'
import { faUser as faUserRegular } from '@fortawesome/free-regular-svg-icons'

import Header from './components/Header'
import MeekijkenHeader from './components/MeekijkenHeader'
import PageLayout from './components/PageLayout'
import Footer from './components/footer/FooterAgent.vue'
import FooterParticipant from './components/footer/FooterParticipant'
import CallAgent from './components/modals/CallAgent'
import FeedbackForm from './components/modals/FeedbackForm'
import ColorPicker from './components/library/ColorPicker'
import './registerServiceWorker'
import { datadogRum } from '@datadog/browser-rum'
import DownloadScriptixTranscriptionModal from './components/modals/ScriptixTranscription'
import MultiStepUpload from './components/modals/MultiStepUpload'
import PrimeVue from 'primevue/config'
import Aura from '@primeuix/themes/aura'
import ToastService from 'primevue/toastservice'
import Tooltip from 'primevue/tooltip'
import { version } from '../package.json'
import TooltipWrapper from './components/TooltipWrapper'
import VuePhoneNumberInput from './components/library/VuePhoneNumberInput.vue'
import JoinTroubleshootButton from './components/JoinTroubleshootButton.vue'
import { eventBus } from './utils/eventBus'
import primevueToastPlugin from './plugins/primevue-toast'
import dateFormatPlugin from './plugins/date-format'
import hotkeyPlugin from './plugins/hotkey'
import { createFeatureFlagPlugin } from 'flagmint-vuejs-feature-flags'
window.version = version
document.querySelector('html').setAttribute('version', version)

if (process.env.VUE_APP_DD_ENABLED === 'true' && process.env.VUE_APP_DD_ENV && ['acceptance', 'sandbox', 'production'].includes(process.env.VUE_APP_DD_ENV)) {
  datadogRum.init({
    applicationId: '07d422cd-f8a6-4df2-82f2-da1f1a453ff7',
    clientToken: 'puba42879dec0e25d2615fbec5e7f3a2e1b',
    site: 'datadoghq.eu',
    service: 'weseedo-app',
    env: process.env.VUE_APP_DD_ENV,
    version: '1.0.0',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input'
  })
}

if (window.location.pathname.indexOf('/meeting/') !== -1 && window.location.href.indexOf('§') !== -1) {
  window.location.href = window.location.href.replace(/§/g, '_')
}

if (window.location.hash !== '') {
  let url = ''
  if (window.location.hash.startsWith('#/login_conversation/')) {
    url = window.location.hash.replace('#/login_conversation/', '/meeting/')
  } else {
    url = window.location.hash.replace('#/', '')
  }
  window.location = url
}

const noSleep = new NoSleep()

window.DetectRTC = DetectRTC
window.EBML = EBML
FontAwesomeIcon.props = FontAwesomeIcon.props || {}
library.add(faTriangleExclamation, faTriangleExclamationSolid, faCircleExclamation, faBell, faBellOn, faPlay, faVolume, faInfoCircle, faArrowUp, faArrowDown, faArrowLeft, faComment, faCommentLines, faPenRuler, faTrashCan, faLineHeight, faEraser, faHorizontalRule, faRotateLeft, faHandPointer, faCircleLight, faSquare, faText, faHighlighter, faPencil, faBars, faMagnifyingGlassMinus, faMagnifyingGlassPlus, faEnvelopesBulk, faCopy, faEllipsisVertical, faClipboardListCheck, faPause, faUserHeadset, faCamera, faVideo, faVideoSolid, faVideoSlash, faMicrophone, faMicrophoneSlash, faSlash, faSpeaker, faComments, faSpinner, faRightFromBracket, faUserClock, faImagePolaroid, faAnglesUp, faAnglesDown, faAnglesLeft, faAnglesRight, faPaperPlane, faPaperclip, faQuestionSquare, faHeartCrack, faWebcam, faWebcamSlash, faXmark, faCheck, faUserLarge, faUserLargeSlash, faClock, faCalendar, faCalendarXmark, faChevronUp, faChevronDown, faChevronLeft, faChevronRight, faTrash, faLink, faPhone, faPhoneHangup, faCircle, faArrowRight, faPlus, faMinus, faChartUser, faFilePdf, faTv, faAngleDown, faAngleUp, faSparkles, faLanguage, faPassport, faCirclePlay, faGear, faHand, faWifiSlash, faLinkSlash, faImage, faFileAudio, faWaveformLines, faFileSignature, faEnvelopeOpen, faTrashSolid, faFlashlight, faHighlighterLine, faEyeDropper, faVolumeXmark, faHeadset, faSolidSpinner, faSquareXmark, faSquareXmarkFree, faSquareXmarkLight, faUserRegular, faCheckCircle, faTimesCircle, faQuestionCircle, faCalendarEdit, faPersonWalkingArrowRight, faUserLock, faMapLocation, faCartShopping, faQrcode, faCircleCheck)
dom.watch()

const app = createApp(App)

app.use(pinia)
store.commit('setProduct', process.env.VUE_APP_PRODUCT)
const webrtc = new Webrtc()

// Meeting diagnostics: client-side quality telemetry for LiveKit calls. Lazy-loaded so it
// stays out of the main bundle, and read-only, so it cannot affect the call. The catch
// makes even a failed chunk load a non-event. VUE_APP_DIAGNOSTICS_ENABLED=false disables
// it at build time (CI flag, inlined into the bundle; a rebuild is required).
import('./diagnostics')
  .then((m) => { if (m.isEnabled()) m.start(webrtc) })
  .catch(() => {})

app.use(router)
app.use(i18n)
app.use(PrimeVue, {
  ripple: true,
  zIndex: {
    overlay: 1100
  },
  theme: {
    preset: Aura,
    options: {
      darkModeSelector: false
    }
  }
})
app.use(ToastService)
app.use(primevueToastPlugin)
app.use(dateFormatPlugin)
app.use(hotkeyPlugin)
app.use(createFeatureFlagPlugin({
  env: 'production', // 'sandbox' | 'production'
  transportMode: 'auto', // or 'websocket'
  apiKey: process.env.VUE_APP_FLAGMINT_API_KEY,
  shareConnection: true, // creates a single connection to server when true, in the case of multiple iframes trying to create seperate connections
  // Env values are strings, so any non-empty value (including 'false') would enable it.
  enableFlagmint: process.env.VUE_APP_ENABLE_FLAGMINT === 'true',
  configSync: true, // local evaluation — download signed rules and run getFlag in-process (default false)
  onError: (error) => {
    const { code, resetTime, message } = error
    console.error('Flagmint Plugin Error:', code, 'Reset Time:', resetTime, 'Message:', message)
  },
  context: {
    kind: "organization",
    key: "wsd-app-anonymous"
  },
  debugLog: process.env.VUE_APP_FLAGMINT_ENV === 'development'  // Enable debug logging in development mode
}))

app.component('file-selector', FileSelector)
app.component('font-awesome-icon', FontAwesomeIcon)
app.component('font-awesome-layers', FontAwesomeLayers)
app.component('weseedo-header', Header)
app.component('meekijken-header', MeekijkenHeader)
app.component('page-layout', PageLayout)
app.component('weseedo-footer', Footer)
app.component('weseedo-footer-participant', FooterParticipant)
app.component('date-picker', DatePicker)
app.component('color-picker', ColorPicker)
app.component('modal-call-agent', CallAgent)
app.component('modal-feedback-form', FeedbackForm)
app.component('vue-password', VuePassword)
app.component('download-scriptix-transcription', DownloadScriptixTranscriptionModal)
app.component('tooltip-wrapper', TooltipWrapper)
app.component('multi-step-upload', MultiStepUpload)
app.component('VuePhoneNumberInput', VuePhoneNumberInput)
app.component('join-troubleshoot-button', JoinTroubleshootButton)

app.directive('tooltip', Tooltip)

app.config.globalProperties.$env = process.env
app.config.globalProperties.$axios = axiosInstance
app.config.globalProperties.$axiosSite = axiosSiteInstance
app.config.globalProperties.$axiosParticipant = axiosParticipantInstance
app.config.globalProperties.$webrtc = webrtc
app.config.globalProperties.$eventBus = eventBus
app.config.globalProperties.$jQuery = jQuery
app.config.globalProperties.$ = jQuery
app.config.globalProperties.moment = moment
app.config.globalProperties.$localStore = localStore
app.config.globalProperties.$noSleep = noSleep
app.config.globalProperties.$utils = new Utils()
app.config.globalProperties.$store = store

webrtc.EventBus.$toast = app.config.globalProperties.$toast

document.addEventListener('click', function enableNoSleep () {
  if (!noSleep.isEnabled() && store.getters.getUser !== false && store.getters.getUser.entity && (store.getters.getUser.entity.id === '60110ee912c04b14f0f5c3e9' || store.getters.getUser.entity.id === '53abbd02e138231d7d1d8810')) {
    noSleep.enable()
  }
}, false)

app.config.errorHandler = (err, instance, info) => {
  console.error('[Vue error]', err, info)
}

router.isReady().then(() => {
  app.mount('#app')
}).catch((err) => {
  console.error('[Router init failed]', err)
  app.mount('#app')
})
